module.exports = __webpack_public_path__ + "assets/img/6266a469f53afabe4dde80bc2a1eb1ba.svg";